import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-stone-100 border-y border-stone-200" data-id="element-140" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-141" data-mp="223oddeaslqbs">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border border-rose-700/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-142" data-mp="222mzz36b0rqw">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-stone-100 text-rose-700 mb-8" data-id="element-143" data-mp="1ed279skcmg4f">
            <ShieldCheck size={48} aria-hidden="true" data-id="element-144" data-mp="qmet4pjuau9f" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-stone-800" data-id="element-145" data-mp="lodcscdst91n">
            Complete 7-Day Guarantee
          </h2>

          <div className="space-y-6 text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-146" data-mp="oxozxwaj2uxq">
            <p data-id="element-147" data-mp="twrycxw062wq">
              Open the complete system. Review the six volumes. Explore the 150
              ready-to-teach classes. Look through the visual techniques,
              student activities, correction tools and assessments.
            </p>
            <p className="font-medium text-stone-800" data-id="element-148" data-mp="61feup17l448">
              If the material qualifies under the terms of the 7-day guarantee,
              contact support within the guarantee period.
            </p>
            <p className="text-rose-900 font-bold text-xl" data-id="element-149" data-mp="f0ako00ccc70">
              You should keep Makeup Instructor Ready because it provides real
              value to your teaching.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}